import React, { useState } from 'react';

import { PublicLayout } from '@/components/PublicLayout';
import { PlanSignupBanner } from '@/components/PublicLayout/components/TeamBeta';
import RedirectDeeplink from '@/components/RedirectDeeplink/RedirectDeeplink';
import {
	ENV_OVERRIDE_STORAGE_KEY,
	privacyPolicyLink,
	termsOfServiceLink,
} from '@/config/constants';
import { useFormattedTitle } from '@/hooks/useFormattedTitle';
import { useFireAnalyticsPageView } from '@/providers/AnalyticsProvider';
import { useSnackbar } from 'notistack';
import { Helmet } from 'react-helmet';
import { useLocalStorage } from 'react-use';

import EmailForm from './components/EmailForm';
import VerifyForm from './components/VerifyForm';

const LoginPage = () => {
	const [email, setEmail] = useState<string | null>(null);
	const [title] = useFormattedTitle('Asaph | Login');
	const [envOverride, setEnvOverride, removeOverride] =
		useLocalStorage<string>(ENV_OVERRIDE_STORAGE_KEY);
	const { enqueueSnackbar } = useSnackbar();

	useFireAnalyticsPageView({
		enabled: !!title,
		pageViewArgs: {
			title,
		},
	});

	return (
		<>
			<RedirectDeeplink />
			<PublicLayout
				renderHeader={<PlanSignupBanner />}
				renderFooter={
					<div className="authentication-content__privacy-policy">
						By logging in or signing up you agree to our
						<br />
						<a
							className="authentication-content__privacy-policy__link"
							href={termsOfServiceLink}
							target="_blank"
							rel="noreferrer"
						>
							Terms of Service
						</a>
						{' and '}
						<a
							className="authentication-content__privacy-policy__link"
							href={privacyPolicyLink}
							target="_blank"
							rel="noreferrer"
						>
							Privacy Policy
						</a>
						{envOverride ? (
							<div className="mt-sm">
								<span>
									You are currently overriding the environment
									to be {envOverride}.
								</span>
								&nbsp;
								<a
									onClick={() => {
										removeOverride();
										enqueueSnackbar(
											'Environment override cleared. You need to restart the app for this to take effect.',
										);
									}}
								>
									Clear override
								</a>
							</div>
						) : null}
					</div>
				}
			>
				<Helmet title={title} />
				{!email && <EmailForm onChange={setEmail} />}
				{!!email && <VerifyForm email={email} onChange={setEmail} />}
			</PublicLayout>
		</>
	);
};

export default LoginPage;
